import { render, staticRenderFns } from "./ResumeCarousel.vue?vue&type=template&id=2dbc36a6&scoped=true&"
import script from "./ResumeCarousel.vue?vue&type=script&lang=js&"
export * from "./ResumeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ResumeCarousel.vue?vue&type=style&index=0&id=2dbc36a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc36a6",
  null
  
)

export default component.exports